import { Button, ButtonGroup } from "@mui/material";
import React, { useEffect, useState } from "react";
import { FieldType, OptionType } from "../../../services/helpers/types";
import { useDispatch } from "react-redux";
import classNames from "classnames";

interface ButtonGroupProps {
  field?: FieldType;
  value?: string;
  onChange?: (value: string) => void;
}

const ButtonGroupField = (props: ButtonGroupProps) => {
  const { field, value = "", onChange } = props;
  const dispatch = useDispatch();
  const [options, setOptions] = useState<OptionType[]>([]);
  useEffect(() => {
    if (field?.options) {
      setOptions(field.options);
    }
  }, [field, dispatch]);

  const handleButtonSelect = (value: string) => {
    if (onChange) {
      onChange(value);
    }
  };
  return (
    <div className="dui-button-group-wrapper">
      <ButtonGroup
        variant="outlined"
        aria-label="Basic button group"
        className="dui-button-group"
      >
        {options.length > 0
          ? options.map((option) => (
              <Button
                key={option.optionID}
                value={option.value}
                className={classNames("dui-button-group-item", {
                  "dui-button-group-item-selected": value === option.value,
                })}
                onClick={() => handleButtonSelect(option.value)}
              >
                {option.name}
              </Button>
            ))
          : null}
      </ButtonGroup>
    </div>
  );
};

export default ButtonGroupField;
